/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum LedHighlightDevice {
    CashAcceptor = 0,
    CardReader = 1,
    CheckReader = 2,
    ReceiptPrinter = 3,
    BarcodeScanner = 4,
}
